import React, {Component} from "react"
import {User} from "@irati/types"
import modalStory from "@irati/utils/modalStory"
import Success from "@irati/ui/src/Success"
import {waitPromise} from "@irati/utils/promise"
import GenericModal from "@irati/ui/src/GenericModal"
import success from "@irati/ui/images/success.svg"
import changeProfilePic from "@irati/images/helpers/changeProfilePic"
import EditProfile from "./EditProfile"

export const SET = "EDIT_AVATAR"
export const SAVED = "SAVED_AVATAR"
const modals = [SET, SAVED]

interface Props {
  user: User
}

interface State {
  show: {[key: string]: boolean}
}

class ProfilePicPopup extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      show: modalStory(modals, null)
    }
  }

  show = (modalToShow = SET) => this.setState({show: modalStory(modals, modalToShow)})

  hide = () => this.setState({show: modalStory(modals, null)})

  handleSubmit = (image: string) => {
    const {user} = this.props

    return changeProfilePic(user, image).then(() => {
      this.show(SAVED)
      waitPromise(2000).then(() => {
        if (this.state.show[SAVED]) this.show(null)
      })
    })
  }

  render() {
    const {user} = this.props
    const {show} = this.state

    return (
      <React.Fragment>
        <GenericModal hideActions show={show[SET]} onHide={this.hide}>
          <EditProfile user={user} onSubmit={this.handleSubmit} selectScreen={this.show} />
        </GenericModal>
        <GenericModal hideActions show={show[SAVED]} onHide={this.hide} image={success}>
          <Success hideSuccessImage />
        </GenericModal>
      </React.Fragment>
    )
  }
}

export default ProfilePicPopup
